import { Box } from '@mui/material';

import ForcedDarkModeBanner from '../components/common/ForcedDarkModeBanner';
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';

export default function B2BLayout({ children }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header userType="b2b" />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      <Footer />
      <ForcedDarkModeBanner />
    </Box>
  );
}
